import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { getSurvey } from '../../../api/surveyQuestion.api';
import ErrorResponse from '../../../components/ErrorResponse';
import SurveyEditor from '../../../components/homepage/survey/SurveyEditor';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import { IGetSurvey } from '../../../models/surveyQuestion.model';

interface IMatch {
  surveyCode: string;
}

const SurveyEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const surveyCode = Number(match.params.surveyCode);
  const { data: res, isLoading, error, execute } = useAxios<IGetSurvey>();

  useEffect(() => {
    if (surveyCode) {
      execute(getSurvey(surveyCode));
    }
  }, [surveyCode]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.survey.title9')}
      />
      <SurveyEditor data={res?.data} />
    </div>
  );
};

export default SurveyEdit;
